import { render, staticRenderFns } from "./PlatformOrganizationList.vue?vue&type=template&id=0ec2f16b&scoped=true&"
import script from "./PlatformOrganizationList.vue?vue&type=script&lang=js&"
export * from "./PlatformOrganizationList.vue?vue&type=script&lang=js&"
import style0 from "./PlatformOrganizationList.vue?vue&type=style&index=0&id=0ec2f16b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2f16b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VDivider,VForm,VIcon,VRow})
